export default __webpack_public_path__ + "static/media/icn_points.aaebbe86.svg";